import React from 'react';
import {Icon} from 'antd';
import Ripple from './../Ripple';
const ButtonCollapseMenu = (props) => {
    return (
        <Ripple onClick={props.onClick}>
            <Icon type={props.collapsed ? 'menu-unfold' : 'menu-fold'} className={props.className}
                            style={{ fontSize: props.size || '25px' }} />
        </Ripple>
    )
}
export default ButtonCollapseMenu;